import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { UserTermVersionListSuccessResponse } from "./api-response/UserTermVersionListSuccessResponse";
import { UserTermListSuccessResponse } from "./api-response/UserTermListSuccessResponse";
import { UserTermSuccessResponse } from "./api-response/UserTermSuccessResponse";
import { map } from "rxjs/operators";

export class ApiUserTerm {
  constructor(private apiEndpoint: string) {}

  listByOrganization(
    token: string,
    organization: string
  ): Observable<UserTermListSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/user-term`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  get(
    token: string,
    organization: string,
    userTermId: string
  ): Observable<UserTermSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/user-term/${userTermId}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  getVersion(
    token: string,
    organization: string,
    userTermVersionId: string
  ): Observable<UserTermListSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/user-term-version/${userTermVersionId}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  updateVersion(
    token: string,
    organization: string,
    userTermVersionId: string,
    data: any
  ): Observable<any> {
    return ajax({
      method: "PUT",
      url: `${this.apiEndpoint}/organizations/${organization}/user-term-version/${userTermVersionId}`,
      headers: getAuthAndDefaultHeaders(token),
      body: data,
    }).pipe(map((x: any) => x.response));
  }

  update(
    token: string,
    organization: string,
    userTermId: string,
    data: any
  ): Observable<any> {
    return ajax({
      method: "PUT",
      url: `${this.apiEndpoint}/organizations/${organization}/user-term/${userTermId}`,
      headers: getAuthAndDefaultHeaders(token),
      body: data,
    }).pipe(map((x: any) => x.response));
  }

  insertVersion(
    token: string,
    organization: string,
    data: any
  ): Observable<any> {
    return ajax({
      method: "POST",
      url: `${this.apiEndpoint}/organizations/${organization}/user-term-version`,
      headers: getAuthAndDefaultHeaders(token),
      body: data,
    }).pipe(map((x: any) => x.response));
  }

  insert(token: string, organization: string, data: any): Observable<any> {
    return ajax({
      method: "POST",
      url: `${this.apiEndpoint}/organizations/${organization}/user-term`,
      headers: getAuthAndDefaultHeaders(token),
      body: data,
    }).pipe(map((x: any) => x.response));
  }

  listVersionsByOrganizationAndUserTerm(
    token: string,
    organization: string,
    userTermId: string
  ): Observable<UserTermVersionListSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/user-term/${userTermId}/version`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }
}
